import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Section } from '../components/ui/Section';
import { ArrowLeft } from 'lucide-react';
export function PrivacyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="min-h-screen w-full bg-[#0f0f23] text-[#f5f0e8] font-sans selection:bg-[#c9a96e] selection:text-[#0f0f23] py-12" data-id="element-207">
      <div className="max-w-3xl mx-auto px-6" data-id="element-208">
        <Link to="/" className="inline-flex items-center text-[#c9a96e] hover:text-[#d4b479] transition-colors mb-8 font-medium" data-id="element-209">
          <ArrowLeft size={20} className="mr-2" data-id="element-210" />
          Back to Home
        </Link>

        <Section className="!py-0" data-id="element-211">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#faf6f0] mb-8" data-id="element-212">
            Privacy Policy
          </h1>
          <p className="text-[#d4cfc5] mb-12 italic" data-id="element-213">
            Last updated: February 2026
          </p>

          <div className="space-y-8 text-lg text-[#f5f0e8] leading-relaxed" data-id="element-214">
            <section data-id="element-215">
              <h2 className="text-2xl font-serif font-bold text-[#faf6f0] mb-4" data-id="element-216">
                1. Information We Collect
              </h2>
              <p data-id="element-217">
                We collect information you provide directly to us when you
                purchase our Product, including your name, email address, and
                payment information. We use third-party payment processors
                (Stripe) and do not store your full credit card details.
              </p>
            </section>

            <section data-id="element-218">
              <h2 className="text-2xl font-serif font-bold text-[#faf6f0] mb-4" data-id="element-219">
                2. How We Use Your Information
              </h2>
              <p data-id="element-220">We use the information we collect to:</p>
              <ul className="list-disc pl-6 mt-4 space-y-2 text-[#d4cfc5]" data-id="element-221">
                <li data-id="element-222">Process your order and deliver the digital product.</li>
                <li data-id="element-223">Send you purchase confirmations and receipts.</li>
                <li data-id="element-224">Respond to your comments, questions, and requests.</li>
                <li data-id="element-225">Communicate with you about updates or related products.</li>
              </ul>
            </section>

            <section data-id="element-226">
              <h2 className="text-2xl font-serif font-bold text-[#faf6f0] mb-4" data-id="element-227">
                3. Sharing of Information
              </h2>
              <p data-id="element-228">
                We do not sell your personal information. We may share your
                information with third-party service providers who perform
                services on our behalf, such as payment processing (Stripe) and
                email delivery. These service providers are authorized to use
                your personal information only as necessary to provide these
                services to us.
              </p>
            </section>

            <section data-id="element-229">
              <h2 className="text-2xl font-serif font-bold text-[#faf6f0] mb-4" data-id="element-230">
                4. Cookies and Tracking
              </h2>
              <p data-id="element-231">
                We use cookies and similar tracking technologies to analyze
                trends, administer the website, and track users' movements
                around the site. You can control the use of cookies at the
                individual browser level.
              </p>
            </section>

            <section data-id="element-232">
              <h2 className="text-2xl font-serif font-bold text-[#faf6f0] mb-4" data-id="element-233">
                5. Data Retention
              </h2>
              <p data-id="element-234">
                We retain your personal information for as long as necessary to
                provide you with our services and as required to comply with our
                legal obligations, resolve disputes, and enforce our agreements.
              </p>
            </section>

            <section data-id="element-235">
              <h2 className="text-2xl font-serif font-bold text-[#faf6f0] mb-4" data-id="element-236">
                6. Your Rights
              </h2>
              <p data-id="element-237">
                You have the right to access, correct, or delete your personal
                information. If you wish to exercise these rights, please
                contact us at hello@betterbysteps.com.
              </p>
            </section>

            <section data-id="element-238">
              <h2 className="text-2xl font-serif font-bold text-[#faf6f0] mb-4" data-id="element-239">
                7. Contact Us
              </h2>
              <p data-id="element-240">
                If you have any questions about this Privacy Policy, please
                contact us at hello@betterbysteps.com.
              </p>
            </section>
          </div>
        </Section>
      </div>
    </main>;
}